import { useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  Box, Collapse, IconButton,
} from '@mui/material'
import { motion } from 'motion/react'
import { useSelector } from 'react-redux'
import { ReactComponent as TimeMachine } from '../../../../images/TimeMachine.svg'
import TitleWithIcon from '../../../../components/Cards/helpers/TitleWithIcon'
import UseTranslation from '../../../../hooks/UseTranslation'
import { arrowRotate } from '../../../../utils/animation'
import { selectNotificationInbox } from '../../../../redux/features/notifications/notificationInbox/notificationInboxSlice'
import emptyBox from '../../../../images/emptyBox.svg'
import HistoryItem from './HistoryItem'

const RequestHistory = () => {
  const [isRequestHistoryOpen, setIsRequestHistoryOpen] = useState(false)
  const { t } = UseTranslation()
  const notificationInboxStore = useSelector(selectNotificationInbox)

  const toggleRequestHistory = () => {
    setIsRequestHistoryOpen((prevState) => !prevState)
  }

  const currentStatusKey = notificationInboxStore?.systemRequestHistory?.status?.key
  const actionOnly = ['COMPLETED_APPROVED', 'COMPLETED_REJECTED', 'TERMINATED'].includes(currentStatusKey)

  return (
    <Box>
      <Box sx={styles.historyHeader}>
        <TitleWithIcon
          title={t?.['Request History']}
          icon={<TimeMachine />}
          textVariant="heading4"
          customStyle={styles.titleWithIcon}
        />
        <IconButton onClick={toggleRequestHistory}>
          {isRequestHistoryOpen ? (
            <ExpandLessIcon
              component={motion.svg}
              variants={arrowRotate}
              initial="initial"
              animate="animate"
              transition="transition"
            />
          ) : (
            <ExpandMoreIcon
              component={motion.svg}
              variants={arrowRotate}
              initial="initial"
              animate="animate"
              transition="transition"
            />
          )}
        </IconButton>
      </Box>
      <Collapse in={isRequestHistoryOpen} sx={styles.historyContent}>
      {notificationInboxStore?.requestHistory?.map((history) => (
         <HistoryItem
            key={history.id}
            isSystem={false}
            history={history}
            styles={styles}
          />
      ))}
        {actionOnly && (
          <HistoryItem
            isSystem
            history={notificationInboxStore?.systemRequestHistory}
            styles={styles}
          />
        )}
        </Collapse>
      {notificationInboxStore?.requestHistory?.length === 0 &&
        !notificationInboxStore?.loading?.fetch && (
      <Collapse in={isRequestHistoryOpen}>
        <TitleWithIcon
          icon={<img src={emptyBox} alt="empty box icon" />}
          title={t?.['No Data to be shown']}
          customStyle={styles.noDataMessage}
        />
      </Collapse>
      )}
    </Box>
  )
}
const styles = {
  historyHeader: {
    display: 'flex',
    alignItems: { xs: 'center', sm: 'baseline' },
    marginBottom: { xs: '0px', sm: '10px' },
  },
  historyContent: {
    padding: { xs: '10px 0px 0px', sm: '0px 0px 0px 50px' },
  },

  employeeName: { fontWeight: 'bold' },
  titleWithIcon: {
    display: 'flex',
    alignItems: 'center',
    margin: { xs: '0px', sm: '20px 0px 0px 20px' },
    '& svg': {
      width: { xs: '15px', sm: '25px' },
      height: { xs: '15px', sm: '25px' },
    },
    '& span': {
      fontFamily: 'Avenir',
      marginLeft: '9px',
    },
  },
  actionItem: {
    display: 'flex',
    alignItems: 'center',
    margin: { xs: '0px', sm: '0px 0px 0px 20px' },
    '& svg': {
      width: { xs: '15px', sm: '25px' },
      height: { xs: '15px', sm: '25px' },
    },
    '& span': {
      fontSize: { xs: '14px', sm: '16px' },
      fontFamily: 'Avenir',
      marginLeft: '5px',
    },
  },
  collapseInfo: {
    display: 'flex',
    alignItems: 'center',
    margin: { xs: '18px 0px', sm: '18px 0px 10px 118px' },
    h5: {
      margin: '0px',
      width: '100%',
      maxWidth: { xs: '70px', sm: 'content-fit' },
      fontWeight: 350,
      fontSize: { xs: '12px', sm: '14px' },
      lineHeight: { xs: '22px', sm: '27.9px' },
      color: 'grey.500',
    },
    h6: {
      width: '100%',
      maxWidth: { xs: '100%', sm: '900px' },
      marginLeft: '61px',
      textAlign: 'left',
      fontWeight: 350,
      fontSize: { xs: '12px', sm: '14px' },
      lineHeight: '27.9px',
      overflowWrap: 'break-word',
    },
  },
  spanName: {
    fontWeight: 'bold',
  },
  noDataMessage: {
    alignItems: 'stretch',
    fontFamily: 'Avenir',
    paddingBlock: '20px',
    justifyContent: 'center',
    '& span': {
      fontSize: '14px',
    },
  },
}
export default RequestHistory
